const __WEBPACK_NAMESPACE_OBJECT__ = require("@radix-ui/react-avatar");